var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-checkbox-group',{attrs:{"options":_vm.filter.checkboxGroup.items},model:{value:(_vm.filter.value),callback:function ($$v) {_vm.$set(_vm.filter, "value", $$v)},expression:"filter.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }